// UX-053: the What Next card used to print the server's own wording and its own
// document count, so one project page showed "peak novelty 78" next to the
// Overview's "whole project 62", and 50 documents next to 54. These helpers
// word the two number-bearing suggestions from the page's single document count
// and say what each score measures.
import type { ProjectStrategicSuggestion } from '../../types'

export interface WhatNextNumbers {
  /** The page's one document count (the same number as the Documents tab badge). */
  documentCount?: number | null
  /** The server's strongest single-document novelty score. */
  strongestDocumentScore?: number | null
  /** The server's own count, used only when the page has none. */
  serverDocumentCount?: number | null
}

export function whatNextDescription(s: ProjectStrategicSuggestion, n: WhatNextNumbers): string {
  const count = n.documentCount ?? n.serverDocumentCount ?? null
  if (s.category === 'expert_review' && count !== null) {
    return `None of your ${count} document${count === 1 ? ' has' : 's have'} been peer-reviewed. Expert feedback can identify blind spots and strengthen your case.`
  }
  if (s.category === 'ip_protection' && n.strongestDocumentScore) {
    return `Your strongest document scores ${n.strongestDocumentScore}/100 for novelty — that is one document, not the whole-project score on the Overview. Filing a provisional patent protects your intellectual property while you continue development.`
  }
  return s.description || s.why_this_matters
}
